import React from 'react';
import ApexchartsContainer from '../../Componant/Charts/ApexCharts';

const Apexcharts = () => {
  return (
    <div className='page-body'>
      <ApexchartsContainer />
    </div>
  );
};

export default Apexcharts;
